<script setup>
// Текст повідомлення з підстановкою емоцій каналу, згадок і посилань.
// Малюємо шматками, а не через v-html: у чат пише хто завгодно, і вставляти
// чужу розмітку в сторінку не варто.
//
// Посилання клікабельні, але показуємо не голий URL, а домен зі шляхом
// (див. useEmotes.tokenize): адреса з хвостом параметрів у вузькій колонці
// чату займає три рядки, а читають у ній усе одно домен. Сам href при цьому
// повний і справжній — підміняти те, куди веде посилання, не можна.
//
// rel="noopener noreferrer nofollow": вкладка з чужим сайтом не має доступу
// до нашої, чужий сайт не бачить, звідки на нього прийшли, а спам у чаті не
// піднімає нікому позиції в пошуку.
//
// loading="lazy" тут навмисно немає: у баблах і в стрічці чату браузер із ним
// просто не починав завантаження, а важать емоції одиниці кілобайт.

const props = defineProps({
  text: { type: String, default: '' },
  // Чиє це імʼя виділяти окремо: звернення особисто до тебе має кидатись у
  // очі в стрічці, що біжить. Порожньо — усі згадки однакові
  me: { type: String, default: '' }
})

const { load, tokenize, emotes } = useEmotes()

onMounted(load)

// emotes у залежностях навмисно: список приїжджає асинхронно, і після цього
// текст треба перерахувати
const parts = computed(() => {
  void emotes.value
  return tokenize(props.text)
})

// Порівнюємо без регістру: у чаті пишуть «@Olsior» і «@olsior», і це той
// самий чоловік
const isMe = (nick) => !!props.me && nick.toLowerCase() === props.me.toLowerCase()
</script>

<template>
  <span class="break-words whitespace-pre-wrap">
    <template
      v-for="(part, index) in parts"
      :key="index"
    >
      <img
        v-if="part.emote"
        :src="part.emote.url"
        :alt="part.emote.name"
        :title="part.emote.name"
        class="inline-block align-middle h-[1.6em] object-contain"
      />

      <!--
        Згадка. Колір ніка той самий, що й у стрічці (рахується з імені),
        тож «@когось» видно тим же кольором, яким підписані його
        повідомлення. Своє імʼя — плашкою: у чаті, що біжить, звернення до
        себе інакше проґавиш
      -->
      <span
        v-else-if="part.mention"
        class="font-semibold"
        :class="isMe(part.mention) ? 'bg-primary/25 px-1 rounded text-primary' : ''"
        :style="isMe(part.mention) ? null : { color: nickColor(part.mention) }"
        >@{{ part.mention }}</span
      >

      <!-- Гіфка з пошуку в чаті — окремим рядком, як картинка -->
      <img
        v-else-if="part.gif"
        :src="part.gif"
        alt="GIF"
        class="block my-1 rounded-md max-w-full max-h-40 object-contain"
        decoding="async"
      />

      <a
        v-else-if="part.link"
        :href="part.link.href"
        target="_blank"
        rel="noopener noreferrer nofollow"
        class="text-primary underline underline-offset-2 hover:opacity-80 break-all"
        :title="part.link.href"
        @click.stop
        >{{ part.link.label }}</a
      >

      <template v-else>{{ part.text }}</template>
    </template>
  </span>
</template>
